import { Component, Inject, CSP_NONCE } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

const cspNonce = document.querySelector('meta[name="CSP_NONCE"]')?.getAttribute('content');

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [{
            provide: CSP_NONCE,
            useValue: cspNonce
        }],
    standalone: false
})
export class AppComponent {
  title = 'Delegation';
  loginDisplay = false;
  isIframe = false;
  loggedIn = false;  
  loggin: any;
 
  private readonly _destroying$ = new Subject<void>();

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
   private broadcastService: MsalBroadcastService,
    private msAuthService: MsalService) { }

  ngOnInit() {
    
    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.setLoginDisplay();
    })
  }

  login() {
    if (this.msalGuardConfig.authRequest){
      this.msAuthService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.msAuthService.loginRedirect();
    }
  }

  logout() { 
    this.msAuthService.logoutRedirect({
      postLogoutRedirectUri: 'http://localhost:4200'
    });
  }
  
  setLoginDisplay() {
    this.loginDisplay = this.msAuthService.instance.getAllAccounts().length > 0;
     let accountData:any= this.msAuthService.instance.getAllAccounts();
     //localStorage.setItem("UserName", accountData[0].username);
     //sessionStorage.setItem("UserName", accountData[0].username);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  
  
}
